
define('text!modules/feedback/directives/user-profile-cta/templates/my-preparation-revise.html',[],function () { return '<a class="link-button c-userProfileCta--bottomLink u-flex-none u-noMargin" ui-sref=app.me.myPerformance.prepare.wizard ng-click=UserProfileCtaCtrl.closeTasks() translate=MY_PERFORMANCE.PREPARATION_REVISE.CTA></a>';});

